import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-provider',
  templateUrl: './provider.component.html'
})
export class ProviderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }




}
